module.exports = __webpack_public_path__ + "static/hero-ee3b23c047c05c9ec016236dd4433b81.jpg";